import _ from 'lodash';
import React from 'react';
import {createSelector} from 'reselect';

import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';

const stepItems = _.mapValues(
    new Array(21),
    (__, id) => ({id, label: window.gettext('Step') + ' ' + Number(id).toOrdinal()}),
);

const onlineItems = {
    True: {id: 'True', label: window.gettext('Online')},
    False: {id: 'False', label: window.gettext('Paper Based')},
};
const restrictedItems = {
    True: {id: 'True', label: window.gettext('Restricted')},
    False: {id: 'False', label: window.gettext('Unrestricted')},
};
const registeredItems = {
    True: {id: 'True', label: window.gettext('Registered')},
    False: {id: 'False', label: window.gettext('Non-Registered')},
};

// اول مهر 1395
// const yearPointer = new window.MomentJalali(1474502400000).subtract(1, 'jMonth');

// اول مهر 1400
const yearPointer = new window.MomentJalali(1632355200000).subtract(1, 'jMonth');
const yearItems = {};
const now = new window.MomentJalali().add(1, 'jMonth');
while (yearPointer < now) {
    let range = yearPointer.toDate().getTime();
    yearPointer.add(1, 'jYear');
    range += ':' + yearPointer.toDate().getTime();
    yearItems[range] = {
        id: range,
        label: ((Number(yearPointer.format('jYYYY')) - 1) + '-' + yearPointer.format('jYY')).persian(),
    };
}
const yearsInitial = [_.last(_.sortBy(_.keys(yearItems)))];

export default function(prefix='', defaults={online: ['False'], years: yearsInitial}) {
    defaults.online = defaults.online || [];
    defaults.restricted = defaults.restricted || [];
    defaults.registered = defaults.registered || [];
    defaults.years = defaults.years || [];
    if (defaults.years === 'default')
    defaults.years = yearsInitial;
    return createSelector(
        [
            store => store.get('gradesTreeFilter'),
            store => store.get('typesTreeFilter'),
            store => store.get('stepsTreeFilter'),
            store => store.get('onlineTreeFilter'),
            store => store.get('restrictedTreeFilter'),
            store => store.get('registeredTreeFilter'),
            store => store.get('yearsTreeFilter'),
        ],
        (gradesTreeFilter, typesTreeFilter, stepsTreeFilter, onlineTreeFilter, restrictedTreeFilter, registeredTreeFilter, yearsTreeFilter) => [
            {
                field: prefix + 'grades',
                label: window.gettext('Examination Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={gradesTreeFilter}
                        header
                        readonly
                        resource='grade'
                        label={window.gettext('Examination Grade')}
                    />
                </div>,
                selected: gradesTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    gradesTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'examination_type',
                label: window.gettext('Type'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={typesTreeFilter}
                        header
                        readonly
                        resource='examination-type'
                        label={window.gettext('Type')}
                    />
                </div>,
                selected: typesTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination-type',
                    typesTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'step',
                label: window.gettext('Step'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={stepsTreeFilter}
                        header
                        readonly
                        resource='examination-step'
                        label={window.gettext('Step')}
                        staticItems={stepItems}
                    />
                </div>,
                selected: stepsTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination-step',
                    stepsTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'online',
                label: window.gettext('Online'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={onlineTreeFilter}
                        header
                        readonly
                        multiSelection={false}
                        resource='examination-online'
                        label={window.gettext('Online')}
                        staticItems={onlineItems}
                        //initial={defaults.online}
                    />
                </div>,
                selected: onlineTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination-online',
                    onlineTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'restricted',
                label: window.gettext('Restricted'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={restrictedTreeFilter}
                        header
                        readonly
                        multiSelection={false}
                        resource='examination-restricted'
                        label={window.gettext('Restricted')}
                        staticItems={restrictedItems}
                        initial={defaults.restricted}
                    />
                </div>,
                selected: restrictedTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination-restricted',
                    restrictedTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'registered',
                label: window.gettext('Registered'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={registeredTreeFilter}
                        header
                        readonly
                        multiSelection={false}
                        resource='examination-registered'
                        label={window.gettext('Registered')}
                        staticItems={registeredItems}
                        initial={defaults.registered}
                    />
                </div>,
                selected: registeredTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination-registered',
                    registeredTreeFilter.get('elementId'),
                )),
            },
            {
                field: '',
                label: window.gettext('Year'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={yearsTreeFilter}
                        header
                        readonly
                        resource='years'
                        label={window.gettext('Year')}
                        staticItems={yearItems}
                        initial={defaults.years}
                    />
                </div>,
                selected: yearsTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'years',
                    yearsTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'date__range',
                selected: yearsTreeFilter.get('selected').size
                    ? {[Number(yearsTreeFilter.get('selected').keySeq().sort().first().split(':')[0] / 1000 - 4017600) + ',' +
                        Number(yearsTreeFilter.get('selected').keySeq().sort().last().split(':')[1] / 1000 - 4017600)]: ''}
                    : {},
            },
            {
                field: prefix + 'books__isnull',
                selected: {True: ''},
            },
            {
                field: prefix + 'react__route',
                selected: { [window.location.pathname]: '' },
            }
        ]
    );
}
